// 数値フォーマット用のユーティリティ関数
// フィールドの値をカンマ区切りでフォーマットする
window.formatNumber = (field, apply = true) => {
  const value = $(field).val().replace(/,/g, ''); // カンマを削除
  if (!/^\d+$/.test(value)) {
    $(field).val('0'); // 不正な場合は0に設定
    return;
  }

  if (!apply) {
    $(field).val(value); // カンマを削除した値をそのまま設定
    return;
  }

  $(field).val(!isNaN(value) && value.trim() !== "" ? parseInt(value, 10).toLocaleString('ja-JP') : '0');
};

